export default __webpack_public_path__ + "static/media/TRX.e3aaf062.svg";